import { render, staticRenderFns } from "./textfield.vue?vue&type=template&id=3f5bd2ff&"
import script from "./textfield.vue?vue&type=script&lang=js&"
export * from "./textfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports